export default {
  GET_LEADS: (state) => state.leads,
  GET_LEAD: (state) => state.lead,
  GET_LEADS_STATUSES: (state) => state.statuses,
};
